import { Button, HStack } from "@chakra-ui/react";
import React from "react";
import { useApproveLeave, useRecallLeave } from "../../services/employeeService";
import { FiCheck, FiX, FiRotateCcw } from "react-icons/fi";

const ListOfLeave = ({ item, refetchLeave }) => {
  const {
    status,
    leave_id,
  } = item;
  
  const { approveLeaveIsLoading, approveLeavePayload } = useApproveLeave((res) => refetchLeave());
  const { recallLeaveIsLoading, recallLeavePayload } = useRecallLeave((res) => refetchLeave());

  const handleApprove = (id, action) => {
    const payload = {
      leave_id: id,
      is_approved: action,
    };
    approveLeavePayload(payload);
  };

  const handleRecall = (id) => {
    const payload = {
      leave_id: id
    };
    recallLeavePayload(payload);
  };

  const isLoading = approveLeaveIsLoading || recallLeaveIsLoading;
  const isPending = status === "Pending";
  const isApproved = status === "Approved";

  return (
    <HStack spacing={2} flexWrap="wrap">
      {/* Reject Button */}
      <Button
        leftIcon={<FiX />}
        colorScheme="red"
        variant="outline"
        size="sm"
        onClick={() => handleApprove(leave_id, false)}
        isLoading={isLoading}
        isDisabled={!isPending}
        borderRadius="8px"
        fontSize="sm"
        fontWeight="500"
        _hover={{ bg: "red.50" }}
      >
        Reject
      </Button>

      {/* Approve Button */}
      <Button
        leftIcon={<FiCheck />}
        colorScheme="green"
        variant="outline"
        size="sm"
        onClick={() => handleApprove(leave_id, true)}
        isLoading={isLoading}
        isDisabled={!isPending}
        borderRadius="8px"
        fontSize="sm"
        fontWeight="500"
        _hover={{ bg: "green.50" }}
      >
        Approve
      </Button>

      {/* Recall Button */}
      <Button
        leftIcon={<FiRotateCcw />}
        colorScheme="gray"
        variant="outline"
        size="sm"
        onClick={() => handleRecall(leave_id)}
        isLoading={isLoading}
        isDisabled={!isApproved}
        borderRadius="8px"
        fontSize="sm"
        fontWeight="500"
        _hover={{ bg: "gray.50" }}
      >
        Recall
      </Button>
    </HStack>
  );
};

export default ListOfLeave;
